import axios from './request_instance';
/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(url, options) {
  const payload = options;
  payload.url = `${url}`;
  payload.data = options.body;
  return axios.request(options);
}
